import _ from 'lodash';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import classnames from 'classnames';

import { ReactComponent as GcpOrgIcon } from 'images/google-domain.svg';
import Drawer from 'common/drawer';
import * as queries from 'hooks/queries';

import './organization-summary.scss';

export const OrganizationSummary = () => {
  const [showDetails, setShowDetails] = React.useState(false);
  const { isLoading, isError, data } = queries.useQueryGetOrganizationsFromJanus();

  let organization = {};
  let billingID = null;
  if (!isLoading && !isError) {
    organization = _.head(data.organizations);
    billingID = organization?.defaultBillingAccountId ? (
      <div>
        GCP Billing ID:
        {organization.defaultBillingAccountId}
      </div>
    ) : null;
  }

  return (
    <section className="bg-gray50 py-4 shadow-sm">
      <div className="rax-racker-google-org-summary container">
        <div aria-label="GCP Organization" className="account-org">
          <div>
            <GcpOrgIcon className={classnames('icon', { loading: isLoading })} />
            {!isLoading && <Button onClick={() => setShowDetails(!showDetails)} size="sm" variant="link" className="p-0"><strong>{organization?.gcpDisplayName}</strong></Button>}
          </div>
          {billingID}
        </div>
      </div>
      <OrganizationDetails showDetails={showDetails} setShowDetails={setShowDetails} organization={organization} />
    </section>
  );
};

const Pair = ({ label, value, className }) => {
  const id = `org-details-key-${_.kebabCase(label)}`;
  return (
    <>
      <strong id={id}>{label}</strong>
      <span aria-labelledby={id} className={className}>{value}</span>
    </>
  );
};

const OrganizationDetails = ({ showDetails, setShowDetails, organization }) => {
  const classes = 'd-grid grid-cols-sm-2 grid-cols-1';
  const BillingAccountListItems = ({ organization }) => {
    const sortedBillingAccounts = _(organization.billingAccounts)
      .map((billingAccount) => ({
        ...billingAccount,
        isDefault: billingAccount.billingAccountId === organization?.defaultBillingAccountId,
      }))
      .sortBy('isDefault')
      .reverse()
      .value();

    return (
      <>
        <Card.Header className="d-flex align-items-center justify-content-between">
          <Card.Title as="h5" className="mb-0">Billing Accounts</Card.Title>
        </Card.Header>
        <ListGroup variant="flush">
          {_.map(sortedBillingAccounts, (billingAccount) => (
            <ListGroup.Item key={billingAccount.billingAccountId} className={classes}>
              <Pair label={billingAccount.displayName} value={billingAccount.billingAccountId} className={classnames({ 'org-details__billing-account-list-item--isDefault': billingAccount.isDefault })} />
            </ListGroup.Item>
          ))}
        </ListGroup>
      </>
    );
  };

  return (
    <Drawer title="Organization Details" backdrop={false} loading={false} handleClick={() => setShowDetails(!showDetails)} show={showDetails}>
      <Card className="border-0">
        <Card.Header className="d-flex align-items-center justify-content-between">
          <Card.Title as="h4" className="mb-0">{organization?.gcpDisplayName}</Card.Title>
        </Card.Header>
        <Card.Body>
          <ListGroup variant="flush">
            <ListGroup.Item className={classes}>
              <Pair label="Organization Id" value={organization?.organizationId} key={organization?.organizationId} />
            </ListGroup.Item>
            <ListGroup.Item className={classes}>
              <Pair label="Directory Customer Id" value={organization?.gcpDirectoryCustomerId} />
            </ListGroup.Item>
          </ListGroup>
          <BillingAccountListItems organization={organization} />
        </Card.Body>
      </Card>
    </Drawer>
  );
};
